import { generateId } from 'src/utils/traceIdGenerations';
import { get, post, put, createHeader,patch } from './mainApi';
import axios from 'axios';
import moment from 'moment';


const onboardingBaseURL = process.env.REACT_APP_Onboarding_SERVICE_ENDPOINT;
const employeeMangementBaseURL = process.env.REACT_APP_EMPLOYEE_MANAGEMENT_SERVICE_ENDPOINT;

const unwrapBody = (resp: any) => {
  if (resp && typeof resp === 'object' && ('status' in resp || 'headers' in resp)) {
    return resp.data;
  }
  return resp;
};

export const getCandidates = async (
  pageNo: number,
  pageSize: number,
  name?: string,
  designation?: string,
  joinedDateFrom?: Date,
  joinedDateTo?: Date,
  status?: string,
  taskIds?:string[],
  onboardStartFrom?: Date,
  onboardStartTo?: Date,
  sortBy?:string,
  sortValue?:string
) => {
  const traceId = generateId(9);
  const params = new URLSearchParams();
  params.append('traceId', traceId);
  if (pageNo !== undefined) params.append('pageNo', String(pageNo));
  if (pageSize !== undefined) params.append('pageSize', String(pageSize));
  if (name) params.append('name', name);
  if (designation) params.append('designation', designation);
  if (status) params.append('status', status);

  if (joinedDateFrom instanceof Date && !isNaN(joinedDateFrom.getTime())) {
    const localFrom = moment(joinedDateFrom).format('YYYY-MM-DD');
    params.append('joinedDateFrom', localFrom);
  }
  if (joinedDateTo instanceof Date && !isNaN(joinedDateTo.getTime())) {
    const localTo = moment(joinedDateTo).format('YYYY-MM-DD');
    params.append('joinedDateTo', localTo);
  }
  if (taskIds?.length) params.append('taskIds', taskIds.join(','));
  if(onboardStartFrom instanceof Date && !isNaN(onboardStartFrom.getTime())){
    const localFrom = moment(onboardStartFrom).format('YYYY-MM-DD');
    params.append('onboardStartFrom', localFrom);
  }
  if(onboardStartTo instanceof Date && !isNaN(onboardStartTo.getTime())){
    const localTo = moment(onboardStartTo).format('YYYY-MM-DD');
    params.append('onboardStartTo', localTo);
  }
  if (sortBy) params.append('sortBy', sortBy);
  if (sortValue) params.append('sortValue', sortValue);

  const resp = await get(`${onboardingBaseURL}candidate?${params.toString()}`);
  return unwrapBody(resp);
};

export const downloadCandidatesReport = async (
  name?: string,
  designation?: string,
  joinedDateFrom?: Date,
  joinedDateTo?: Date,
  status?: string,
  taskIds?:string[],
  onboardStartFrom?: Date,
  onboardStartTo?: Date,
  sortBy?:string,
  sortValue?:string
) => {
  const traceId = generateId(9);
  const params = new URLSearchParams();
  params.append('traceId', traceId);
  if (name) params.append('name', name);
  if (designation) params.append('designation', designation);
  if (status) params.append('status', status);

 if (joinedDateFrom instanceof Date && !isNaN(joinedDateFrom.getTime())) {
    const localFrom = moment(joinedDateFrom).format('YYYY-MM-DD');
    params.append('joinedDateFrom', localFrom);
  }
  if (joinedDateTo instanceof Date && !isNaN(joinedDateTo.getTime())) {
    const localTo = moment(joinedDateTo).format('YYYY-MM-DD');
    params.append('joinedDateTo', localTo);
  }
  if (taskIds?.length) params.append('taskIds', taskIds.join(','));
 if(onboardStartFrom instanceof Date && !isNaN(onboardStartFrom.getTime())){
    const localFrom = moment(onboardStartFrom).format('YYYY-MM-DD');
    params.append('onboardStartFrom', localFrom);
  }
  if(onboardStartTo instanceof Date && !isNaN(onboardStartTo.getTime())){
    const localTo = moment(onboardStartTo).format('YYYY-MM-DD');
    params.append('onboardStartTo', localTo);
  }
  if (sortBy) params.append('sortBy', sortBy);
  if (sortValue) params.append('sortValue', sortValue);

  const resp = await axios.get(
    `${onboardingBaseURL}candidate/export?${params.toString()}`,
    {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
    }
  );

  return resp.data;
};

export const createCandidate = async (candidateData) => {
  const traceId = generateId(9);
  const params = new URLSearchParams();
  params.append('traceId', traceId);

  const response = await post(`${onboardingBaseURL}candidate/create_candidate?${params.toString()}`, candidateData);
  return response.data;
};


export const getCandidateById = async (candidateId: number) => {
  const traceId = generateId(9);
  const response = get(`${onboardingBaseURL}candidate/${candidateId}?traceId=${traceId}`);

  return response;
};

export const updateCandidate = async (candidateId: number, candidateData: any) => {
  const traceId = generateId(9);
  const response = await put(`${onboardingBaseURL}candidate/${candidateId}?traceId=${traceId}`, candidateData);

  return response;
};

export const getTaskList = async () => {
  const traceId = generateId(9);
  var response = get(`${onboardingBaseURL}task?traceId=${traceId}`);
  return response;
};

export const updateOnboardingTask = async (
  type: 'T' | 'S',
  id: number,
  payload: {
    officialEmail?: string;
    assetId?: string; // <-- if BE uses snake_case, map accordingly
    comment?: string;
  }
) => {
  const traceId = generateId(9);
  const url = `${onboardingBaseURL}task/${type}/${id}?traceId=${traceId}`;

  const resp = await put(url, payload ?? {});
  const data = unwrapBody(resp);

  if (data?.statusCode && data.statusCode !== 200) {
    throw new Error(data.message || 'Failed to update task');
  }

  return data;
};

export const updateTaskStatus = async (
  type: 'T' | 'S',
  id: number,
  status: string
) => {
  const traceId = generateId(9);
  const url = `${onboardingBaseURL}task/update-status/${type}/${id}?traceId=${traceId}&status=${status.toUpperCase()}`;

  const resp = await put(url, {});
  const data = unwrapBody(resp);

  if (data?.statusCode && data.statusCode !== 200) {
    throw new Error(data.message || 'Failed to update task status');
  }

  return data;
};


export const getOnboardingDetailsById = async (onboardingId: number) => {
  const traceId = generateId(9);
  const url = `${onboardingBaseURL}onboarding/${onboardingId}?traceId=${traceId}`;
  const config = await createHeader();
  const resp = await get(url, config);      
  return unwrapBody(resp);                   
};

export const findCandidateByScanning = async (id: number, pageSize = 10, maxPages = 100) => {
  for (let pageNo = 0; pageNo < maxPages; pageNo++) {
    const res = await getCandidates(pageNo, pageSize);
    const list = res?.data?.candidatesList ?? res?.candidatesList ?? [];
    if (!Array.isArray(list) || list.length === 0) break;

    const match = list.find((c: any) => String(c.id) === String(id));
    if (match) return match;
  }
  return null;
};

export const startOnboarding = async (candidateId:number) => {
  const traceId = generateId(9);
  const response = get(`${onboardingBaseURL}onboarding/start-onboarding/${candidateId}?traceId=${traceId}`);
  return response;
};

export const getHasOnboardingStarted = async (candidateId:number) => {
  const traceId = generateId(9);
  const response = get(`${onboardingBaseURL}onboarding/has-onboarding-started/${candidateId}?traceId=${traceId}`);
  return response;
};

export const updateEmsUserCreated = async (
  candidateId: number,
  isEmsUserCreated: boolean
) => {
  const traceId = generateId(9);
  const params = new URLSearchParams();
  params.append('candidateId', String(candidateId));
  params.append('is_ems_user_created', String(isEmsUserCreated));
  params.append('traceId', traceId);

  const resp = await patch(
    `${onboardingBaseURL}candidate/ems-user-created?${params.toString()}`,
    {}
  );
  return resp.data ?? resp;
};

export const getTaskHistoryLog = async (TaskId:number) => {
  const traceId = generateId(9);
  const response = get(`${onboardingBaseURL}task/${TaskId}?traceId=${traceId}`);
  return response;
};

export const createDocumentAcknowledgement = async (employeeId:string) => {
  const traceId = generateId(9);
  const response = await post(`${employeeMangementBaseURL}document_acknowledgement/create?traceId=${traceId}`,{ employeeId });
  return response;
};